import { IMAGE_BASE_URL } from "../variables/constants";

export const buildImageLink = (image: string) => `${IMAGE_BASE_URL}/${image}`;